// extracted by mini-css-extract-plugin
export default {"root":"StateText_root__FPAbT","info":"StateText_info__FjG3l"};